import React, { useState, useEffect, useRef } from 'react';
import './MemberCenter.css';

import { PageTitle, ParkingInfo } from '../../../components';
import { renderIcon } from '../../../utils';
import { memberFeatures } from '../../../constants';

import { Link, useLocation, useNavigate } from 'react-router-dom';

import Cookies from 'js-cookie';
import { MessageModal } from '../../../components';
import { useTokenCheck, getCurrentStatus } from '../../../constants';
import CookieConsentModal from '../../../components/CookieConsentModal/CookieConsentModal';

const MemberCenter = () => {
  const navigate = useNavigate();

  const [name, setName] = useState('');
  const [parkingInfoData, setParkingInfoData] = useState([]);

  const { nickName, isCanExecute } = useTokenCheck();
  useEffect(() => {

    if (!isCanExecute) return;
    setName(nickName);
    getCurrentStatus().then(payload => {
      const isPayloadValid =
        payload?.status !== undefined &&
        payload?.errorCode !== undefined &&
        payload?.data !== undefined &&
        payload?.errorMessage !== undefined;

      if (isPayloadValid) {
        if (payload.status === 0 && payload.errorCode === '0000') {
          // 處理結果
          setParkingInfoData(payload.data);
        } else if (payload.status === 1 &&
          (payload.errorCode === '9997' || payload.errorCode === '9998')) {
          //未登入
          let errorMessage = "Token過期，或發生異常，需要重新登入！";
          MessageModal.alert(errorMessage, () => navigate('/lineLogin'));
        } else if (payload.status === 1 && payload.errorCode === '9996') {
          //查無此會員，只有被刪帳號或未完成註冊流程第一頁，理論上一進頁面tokenInfo就會擋掉
          let errorMessage = "查無此會員，或發生異常，需要重新登入！";
          MessageModal.alert(errorMessage, () => navigate('/lineLogin'));
        } else {
          let errorMessage = payload.errorMessage;
          MessageModal.alert(errorMessage);
        }
      }
    }).catch(error => {
      console.error('Error during API call:', error);
    });

  }, [isCanExecute]);

  return (
    <>
      {/* 確認是否使用cookies */}
      <CookieConsentModal />

      {/* Page Title */}
      <PageTitle title={'本次停車'} page={'member center'} />

      <section className='service-single'>

        <div className='sidebar service-sidebar'>

          <div className='category sidebar-item'>

            {/* <SidebarHeading title={''} /> */}

            <div className='box-container'>
              {memberFeatures.map(memberFeatures => {
                return (
                  /* Link to the individual service page */
                  <Link
                    to={{
                      pathname: memberFeatures.link,
                    }}
                    location={{ memberFeatures }}
                    state={memberFeatures}
                    key={memberFeatures.id}
                    className='item'><span><div className='icon'>{renderIcon(memberFeatures.title)}</div>{memberFeatures.title}</span> {/* Service Title */}
                  </Link>)
              })}
            </div>

          </div>

        </div>

        <div className='service-info'>

          <div className='content'>

            {/* Service heading */}
            <h3 className='main-heading'>{name} 您好，</h3>

            <ParkingInfo parkingRecords={parkingInfoData} emptyMessage={'目前沒有需要繳費的紀錄'} />

          </div>
        </div>

      </section>
    </>
  );
}

export default MemberCenter;
